import { SuperBillControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useArchiveSuperBill = () =>
  useMutationWithLoading(
    async (param: { superBillId: string; status: boolean }) =>
      new SuperBillControllerApi(
        getConfigObject()
      ).updateSuperBillArchiveStatus(
        param.superBillId,
        param.status,
        getXtenantId()
      )
  );
